import PageHandlersService from '@/utils/page-handlers-service';
import SlimSelect from 'slim-select';

const pageHandlers = new PageHandlersService();

const init = () => {
    const partnersFiltersCitySelectWrapper = document.querySelector('.js-partners-filters-city-mobile-wrapper');
    const partnersFiltersCitySelect = document.querySelector('.js-partners-filters-city-mobile');
    const selectArrow = partnersFiltersCitySelectWrapper?.querySelector('.js-select-arrow');

    const handleSelectFocus = () => {
        selectArrow?.classList.add('active');

        const selectContent = partnersFiltersCitySelectWrapper?.querySelector<HTMLElement>('.ss-content');

        if (selectContent) {
            selectContent.style.height = `${selectContent.scrollHeight}px`;
        }
    };

    const handleSelectBlur = () => {
        selectArrow?.classList.remove('active');

        const selectContent = partnersFiltersCitySelectWrapper?.querySelector<HTMLElement>('.ss-content');

        if (selectContent) {
            selectContent.style.height = '0px';
        }
    };

    if (partnersFiltersCitySelect) {
        const citySelect = new SlimSelect({
            select: partnersFiltersCitySelect,
            showSearch: false,
            searchFocus: false,
            beforeOpen: handleSelectFocus,
            beforeClose: handleSelectBlur,
        });

        pageHandlers.addDestroy(() => {
            citySelect.destroy();
        });

        pageHandlers.set(
            window,
            () => {
                citySelect.close();
            },
            'scroll',
        );
    }
    // }
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
